import { remove } from 'lodash';
import {
  REQUEST_GROUP_LIST_SUCCESS,
  REQUEST_GROUP_LIST_FAILURE,
  ADD_GROUP_SUCCESS,
  ADD_GROUP_FAILURE,
  DELETE_GROUP_SUCCESS
} from '../constants/actionTypes';

const INITIAL_STATE = { ids: [], errors: null };

export default function groupManager(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_GROUP_LIST_SUCCESS:
      return { ...state, ids: action.payload.data.map((data) => data.id), errors: null };
    case REQUEST_GROUP_LIST_FAILURE:
      return { ...state, ids: [], errors: action.payload.response && action.payload.response.data.errors };
    case ADD_GROUP_SUCCESS:
      return { ...state, ids: [ ...state.ids, action.payload.data.id ], errors: null };
    case ADD_GROUP_FAILURE:
      return { ...state, errors: action.payload.response && action.payload.response.data.errors };
    case DELETE_GROUP_SUCCESS:
      return { ...state, ids: remove(state.ids, (id) => id !== action.payload.data.id), errors: null };
    default:
      return state;
  }
}
